import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-invoice-card",
  "use": "icon-invoice-card-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-invoice-card\"><g transform=\"rotate(-45 8.954 -.438)\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"m2.372-.65 3.421 3.194.181 6.73-6.251.389-.36-6.633L2.372-.65z\" stroke=\"currentColor\" stroke-width=\"1.25\" /><circle fill=\"currentColor\" cx=\"2.667\" cy=\"3\" r=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol